import { Uuid } from '@ftr/contracts/type/shared'
import { GoldSttContext, matchGoldSttContext } from './gold-stt-context'

/*
 * This is used by the Recording Playback Page.
 * We are listen to socket events and query data based on the RecordingId.
 * We use the TranscriptId to differentiate between sessions when
 * the GET TEXT button is clicked.
 */

export interface GoldRecordingSttContext {
  type: 'recording'
  recordingId: Uuid
  hasStt: boolean
}

export function buildGoldRecordingSttContext(recordingId: Uuid, hasStt: boolean): GoldRecordingSttContext {
  return {
    type: 'recording',
    recordingId,
    hasStt,
  }
}

export const goldRecordingSttContextEquals =
  (other: GoldSttContext) =>
  (self: GoldRecordingSttContext): boolean =>
    matchGoldSttContext(other, {
      mapAudioOrder: () => false,
      mapRecording: ({ recordingId }) => recordingId === self.recordingId,
      mapSharedRecording: () => false,
    })
